import { render, staticRenderFns } from "./ResultsBenefits.vue?vue&type=template&id=3450ff94&"
import script from "./ResultsBenefits.vue?vue&type=script&lang=js&"
export * from "./ResultsBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports